"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlueBaseAppError = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_native_1 = require("react-native");
const components_1 = require("../../components");
const utils_1 = require("../../utils");
const MISSING_ERROR = 'An unknown error occurred.';
const BlueBaseAppError = ({ progress, error: err, BB }) => {
    const error = err || (progress && progress.error);
    let development = BB.Configs.getValue('development');
    if (development === undefined) {
        development = !utils_1.isProduction();
    }
    const message = development === true && error ? error.message : MISSING_ERROR;
    const reload = () => BB.reboot();
    return (react_1.default.createElement(components_1.WaitObserver, { delay: 100 },
        react_1.default.createElement(react_native_1.ScrollView, { contentContainerStyle: { flexGrow: 1 } },
            react_1.default.createElement(react_native_1.SafeAreaView, { style: { alignItems: 'center', flexGrow: 1, justifyContent: 'center', padding: 16 } },
                react_1.default.createElement(react_native_1.View, { style: {
                        borderColor: 'rgb(244, 67, 54)',
                        borderRadius: 8,
                        borderWidth: 1,
                        minWidth: 200,
                    } },
                    react_1.default.createElement(react_native_1.Text, { style: {
                            backgroundColor: 'rgba(244, 67, 54, .1)',
                            borderBottomWidth: 1,
                            borderColor: 'rgb(244, 67, 54)',
                            borderTopLeftRadius: 4,
                            borderTopRightRadius: 4,
                            color: 'rgba(244, 67, 54, 1)',
                            fontWeight: 'bold',
                            padding: 8,
                            textAlign: 'center',
                        }, testID: "error-title" }, "ERROR"),
                    react_1.default.createElement(react_native_1.Text, { style: { padding: 16 }, testID: "error-message" }, message),
                    react_1.default.createElement(react_native_1.View, { style: {} },
                        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: reload, testID: "error-button" },
                            react_1.default.createElement(react_native_1.Text, { style: {
                                    backgroundColor: 'rgba(76, 175, 80, .1)',
                                    borderColor: 'rgb(76, 175, 80)',
                                    borderRadius: 4,
                                    borderWidth: 1,
                                    color: 'rgb(76, 175, 80)',
                                    fontWeight: 'bold',
                                    margin: 8,
                                    padding: 8,
                                    textAlign: 'center',
                                } }, "RELOAD"))))))));
};
exports.BlueBaseAppError = BlueBaseAppError;
exports.BlueBaseAppError.displayName = 'BlueBaseAppError';
